import type { Card, DrawMode, GameState } from "./types.ts";
import { TABLEAU_COUNT, FOUNDATION_COUNT } from "./types.ts";
import { shuffledDeck } from "./deck.ts";
import { randomSeed } from "./rng.ts";
import { DEFAULT_SCORING_SYSTEM } from "./play-score.ts";

// Lay out a Klondike deal from a shuffled deck:
// pile 0 has 1 card, pile 1 has 2, ..., pile 6 has 7. Top card of each pile is face-up.
// Remaining 24 cards form the stock.
export function dealKlondike(seed: string, drawMode: DrawMode): GameState {
  const deck = shuffledDeck(seed);

  const tableau: Card[][] = Array.from({ length: TABLEAU_COUNT }, () => []);
  const foundation: Card[][] = Array.from(
    { length: FOUNDATION_COUNT },
    () => [],
  );

  let cursor = 0;
  for (let col = 0; col < TABLEAU_COUNT; col++) {
    for (let row = 0; row <= col; row++) {
      const card = deck[cursor++]!;
      const isTop = row === col;
      tableau[col]!.push({ ...card, faceUp: isTop });
    }
  }

  const stock = deck.slice(cursor).map((c) => ({ ...c, faceUp: false }));

  return {
    tableau,
    foundation,
    stock,
    waste: [],
    drawMode,
    stockRecycles: 0,
    scoringSystem: DEFAULT_SCORING_SYSTEM,
    score: 0,
    moves: 0,
    startedAt: Date.now(),
    elapsedMs: 0,
    undoStack: [],
    hintsUsed: 0,
    undosUsed: 0,
    finished: false,
    won: false,
    seed,
    joker: {
      usedThisGame: false,
      pendingSpend: false,
    },
  };
}

export function newDeal(drawMode: DrawMode): GameState {
  return dealKlondike(randomSeed(), drawMode);
}
